import { useGetEmissorContractAddressesQuery } from '../services/contractAddressesApi';
const EMPTY_ADDRESSES = [];
export function useEmissorContractAddresses({ contractId, enabled = true, }) {
    const shouldSkip = !enabled || !contractId;
    const state = useGetEmissorContractAddressesQuery({ contractId: contractId ?? '' }, { skip: shouldSkip });
    const addresses = state.data ?? EMPTY_ADDRESSES;
    const primaryAddress = addresses.find(address => address.isPrimary) ?? addresses[0] ?? null;
    return {
        addresses,
        primaryAddress,
        isLoading: state.isLoading || state.isFetching,
        isError: state.isError,
        refetch: state.refetch,
    };
}
